import extractDataFromMap from "../../../utils/ExtractDataFromMap";
import { format } from "date-fns";

const PrintableTableFooterRow = (props) => {
  const { settings, data } = props;

  const classStyleStart = ` border-zinc-300 border border-t-0 px-2 h-full pb-2 pt-3 `;
  const classStyleMiddleEnd = ` border-zinc-300 border border-t-0 border-l-0 px-2 h-full pb-2 pt-3 `;

  return (
    <tfoot>
      <tr className="row-start-start text-sm bg-zinc-100 font-semibold text-slate-800 ">
        {settings.map((setting, index) => {
          const randomKey = Math.random().toString(5).substring(2) + index;

          let contentTxt = "";
          const value =
            setting.type === "*"
              ? ""
              : extractDataFromMap({
                  key: setting.field,
                  map: data,
                });
          if (setting.type === "*") {
            contentTxt = setting.label;
          } else if (setting.type === "number") {
            contentTxt = (value ?? 0).toLocaleString("id-ID", {
              maximumFractionDigits: setting.maxFraction ?? 2,
              minimumFractionDigits: setting.minFraction ?? 0,
            });
          } else if (setting.type === "date") {
            if (value != null) {
              const dateObject = new Date(value);
              contentTxt = isNaN(dateObject.getTime())
                ? "-"
                : format(dateObject, "dd/MM/yyyy");
            }
          } else if (setting.type === "datetime") {
            if (value != null) {
              const dateObject = new Date(value);
              contentTxt = isNaN(dateObject.getTime())
                ? "-"
                : format(dateObject, "dd/MM/yyyy HH:mm");
            }
          } else if (setting.type === "currency") {
            contentTxt = new Intl.NumberFormat("id-ID", {
              style: "currency",
              currency: "IDR",
              minimumFractionDigits: 0,
            }).format(value || 0);
          } else {
            contentTxt = value;
          }

          return (
            <td
              key={randomKey}
              colSpan={setting.colSpan ?? 1}
              className={`${
                index === 0 ? classStyleStart : classStyleMiddleEnd
              } ${setting.width} ${setting.layout}`}
            >
              {contentTxt}
            </td>
          );
        })}
      </tr>
    </tfoot>
  );
};

export default PrintableTableFooterRow;
